import axiosInstance from "./axios/axios_instance"
const http = axiosInstance("/public",  null, "/forbidden")

const getTeamCategories = () => http.get("team_categories");

export default {
    getTeamCategories
}
